/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Profile_Why_PrefixInputs */

const en_us2_profile_why_prefix = /** @type {(inputs: Profile_Why_PrefixInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Why we ask:`)
};

const pt_br2_profile_why_prefix = /** @type {(inputs: Profile_Why_PrefixInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Por que perguntamos:`)
};

const es_419_profile_why_prefix = /** @type {(inputs: Profile_Why_PrefixInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Por qué lo preguntamos:`)
};

const pt_pt2_profile_why_prefix = /** @type {(inputs: Profile_Why_PrefixInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Porque perguntamos:`)
};

const fr_fr2_profile_why_prefix = /** @type {(inputs: Profile_Why_PrefixInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Pourquoi on demande :`)
};

const de_de2_profile_why_prefix = /** @type {(inputs: Profile_Why_PrefixInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Warum wir fragen:`)
};

const it_it2_profile_why_prefix = /** @type {(inputs: Profile_Why_PrefixInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Perché lo chiediamo:`)
};

/**
* | output |
* | --- |
* | "Why we ask:" |
*
* @param {Profile_Why_PrefixInputs} inputs
* @param {{ locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }} options
* @returns {LocalizedString}
*/
const profile_why_prefix = /** @type {((inputs?: Profile_Why_PrefixInputs, options?: { locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Profile_Why_PrefixInputs, { locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "pt-BR") return pt_br2_profile_why_prefix(inputs)
	if (locale === "es-419") return es_419_profile_why_prefix(inputs)
	if (locale === "pt-PT") return pt_pt2_profile_why_prefix(inputs)
	if (locale === "fr-FR") return fr_fr2_profile_why_prefix(inputs)
	if (locale === "de-DE") return de_de2_profile_why_prefix(inputs)
	if (locale === "it-IT") return it_it2_profile_why_prefix(inputs)
	return en_us2_profile_why_prefix(inputs)
});
export { profile_why_prefix as "profile.why_prefix" }